import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

const Line: React.FC<{ borderColorClass: Props['borderColorClass'] }> = ({
  borderColorClass = 'border-text-color',
}) => {
  return <div className={`h-[1px] flex-grow border-0 border-t-[2px] border-solid ${borderColorClass}`} />
}

type Props = { borderColorClass?: string; padded?: boolean; children: React.ReactNode; className?: string }

const TextDivider: React.FC<Props> = ({ children, borderColorClass, padded, className }) => {
  return (
    <div className={cn('flex items-center', padded && 'px-4', className)}>
      <Line {...{ borderColorClass }} />
      <div className="px-4">{children}</div>
      <Line {...{ borderColorClass }} />
    </div>
  )
}

export default TextDivider
